"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var themes_1 = require("../../themes");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var fixedLabel = _a.fixedLabel, borderColor = _a.borderColor, error = _a.error, fixedHeight = _a.fixedHeight, disabled = _a.disabled;
            return ({
                '& .MuiFormLabel-root': {
                    top: 10,
                },
                '& .MuiSelect-select': {
                    display: 'flex',
                    alignItems: 'center',
                },
                '& .MuiInputBase-input': {
                    fontSize: '13px',
                    height: fixedHeight ? '23px' : undefined,
                },
                '& .MuiInputBase-input::placeholder': {
                    color: themes_1.materialColors.grey[200],
                    opacity: 1,
                },
                '& .MuiInputLabel-filled': {
                    fontWeight: fixedLabel ? 800 : 400,
                    fontSize: '13px',
                },
                '& .MuiInputLabel-filled:not(.Mui-disabled)': {
                    color: themes_1.materialColors.grey[500],
                    fontWeight: 400,
                },
                '& .MuiInputLabel-filled.Mui-disabled': {
                    color: themes_1.materialColors.grey[200],
                },
                '& .MuiInputLabel-filled.MuiInputLabel-shrink': {
                    textTransform: 'uppercase',
                    // move shrunk label above input a bit farther
                    transform: 'translate(2px, -2px) scale(0.75)',
                    '&.Mui-error': {
                        color: theme.palette.error.main,
                    },
                },
                '& .MuiFilledInput-root': {
                    backgroundColor: '#fff',
                },
                '& .MuiOutlinedInput-root': {
                    backgroundColor: disabled ? themes_1.materialColors.grey[100] : '#fff',
                    borderRadius: '8px',
                    color: disabled ? themes_1.materialColors.grey[400] : undefined,
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: error
                            ? theme.palette.error.main
                            : borderColor || theme.palette.primary.contrastText,
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: error ? theme.palette.error.main : themes_1.materialColors.blue[900],
                    },
                },
                '& .MuiFilledInput-input': {
                    paddingLeft: 4,
                    paddingBottom: 8,
                },
                '& .MuiFilledInput-underline::before, & .MuiFilledInput-underline::after': {
                    borderBottomWidth: '2px',
                    borderBottomStyle: 'solid',
                },
                '& .MuiFilledInput-underline.Mui-disabled::before, & .MuiFilledInput-underline.Mui-disabled::after': {
                    borderBottomColor: themes_1.materialColors.grey[200],
                },
                '& .MuiFilledInput-underline:not(.Mui-error):not(.Mui-disabled)::before': {
                    borderBottomColor: theme.palette.primary.main,
                },
                '& .MuiFilledInput-underline:not(.Mui-error):not(.Mui-disabled)::after': {
                    borderBottomColor: theme.palette.primary.dark,
                },
                // when used with options
                '& .MuiMenuItem-root': {
                    fontSize: '13px',
                },
                '& .MuiFormHelperText-contained': {
                    marginLeft: 2,
                },
                '& .MuiFormHelperText-root': {
                    '&.Mui-error': {
                        fontWeight: 700,
                    },
                },
            });
        },
    });
});
